import * as types from './action_types';
import WordService from '../../services/word_service';

export const search = (wordText) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.WORD_SEARCHING });
      const suggestedWordTexts = await WordService.search(wordText);
      dispatch({ type: types.WORD_SEARCHED, suggestedWordTexts });
    } catch(error) {
      dispatch({ type: types.WORD_SEARCH_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/word_search/actions.js